import { Card, Divider, Typography, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { formCardStyle } from '../../../TransitionStyles';
import { CLINICAL } from '../../../formQuestionsEnum';
import PhysicianSection from './PhysicianSection';
import FormTitle from '../../../FormFields/FormTitle';
import PhysicianSectionAddMore from './PhysicianSectionAddMore';

PhysicianServicesForm.propTypes = {
  permissions: PropTypes.object,
};
export default function PhysicianServicesForm({ permissions }) {
  const showForm = [
    CLINICAL.PODIATRIST,
    CLINICAL.EYE_CARE,
    CLINICAL.DENTAL,
    CLINICAL.AUDIOLOGY,
    CLINICAL.ADDITIONAL_MEDICAL_PROFESSIONALS,
  ].some(({ id }) => id in permissions);

  const ADDITIONAL_MEDICAL_PROFESSIONALS = 5;

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Physician Services
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {CLINICAL.PODIATRIST.id in permissions && (
            <>
              <Grid item xs={12}>
                <FormTitle fieldAttributes={{ questionTitle: 'Podiatrist', fieldType: 'title' }} />
              </Grid>
              <PhysicianSection
                isEditable={permissions[CLINICAL.PODIATRIST.id]}
                fieldName={`${CLINICAL.PODIATRIST.fieldName}[0]`}
              />
            </>
          )}
          {CLINICAL.EYE_CARE.id in permissions && (
            <>
              <Grid item xs={12}>
                <FormTitle fieldAttributes={{ questionTitle: 'Eye care', fieldType: 'title' }} />
              </Grid>
              <PhysicianSection
                isEditable={permissions[CLINICAL.EYE_CARE.id]}
                fieldName={`${CLINICAL.EYE_CARE.fieldName}[0]`}
              />
            </>
          )}
          {CLINICAL.DENTAL.id in permissions && (
            <>
              <Grid item xs={12}>
                <FormTitle fieldAttributes={{ questionTitle: 'Dental', fieldType: 'title' }} />
              </Grid>
              <PhysicianSection
                isEditable={permissions[CLINICAL.DENTAL.id]}
                fieldName={`${CLINICAL.DENTAL.fieldName}[0]`}
              />
            </>
          )}
          {CLINICAL.AUDIOLOGY.id in permissions && (
            <>
              <Grid item xs={12}>
                <FormTitle fieldAttributes={{ questionTitle: 'Audiology', fieldType: 'title' }} />
              </Grid>
              <PhysicianSection
                isEditable={permissions[CLINICAL.AUDIOLOGY.id]}
                fieldName={`${CLINICAL.AUDIOLOGY.fieldName}[0]`}
              />
            </>
          )}
          {CLINICAL.ADDITIONAL_MEDICAL_PROFESSIONALS.id in permissions && (
            <>
              <Grid item xs={12}>
                <FormTitle
                  fieldAttributes={{ questionTitle: 'Additional medical professionals', fieldType: 'title' }}
                />
              </Grid>
              <PhysicianSectionAddMore
                isEditable={permissions[CLINICAL.ADDITIONAL_MEDICAL_PROFESSIONALS.id]}
                fieldName={CLINICAL.ADDITIONAL_MEDICAL_PROFESSIONALS.fieldName}
                physicianTypeId={ADDITIONAL_MEDICAL_PROFESSIONALS}
              />
            </>
          )}
        </Grid>
      </Card>
    )
  );
}
